const firebaseConfig = {
    apiKey: "AIzaSyDreXaeLDkMvF--_wP-pv6j3Gh-U05AXGc",
    authDomain: "nishat--portfolio.firebaseapp.com",
    projectId: "nishat--portfolio",
    storageBucket: "nishat--portfolio.appspot.com",
    messagingSenderId: "638290760328",
    appId: "1:638290760328:web:0db6a52c33fc15e524053d"
  };
  export default firebaseConfig; 